// Apresentacao das mensalidades na visao do aluno (financeiro e tela inicial).
import i18n from "@/plugins/i18n";

// Card 86ak0nkuq: o mes de referencia e o que identifica a cobranca para o
// aluno ("Maio/26"), nao o codigo da turma.
export function chargeMonthLabel(month, year) {
  const monthNumber = Number(month);
  if (!(monthNumber >= 1 && monthNumber <= 12) || !year) return "";
  const name = i18n.t(`enums.month.${monthNumber}`);
  return `${name}/${String(year).slice(-2)}`;
}

// Quem e de onde: professor e codigo da turma. A cobranca do aluno solo e da
// plataforma -- nem o tutor nem um codigo de turma (que nao existe) entram.
export function chargeOriginParts(charge) {
  if (!charge || charge.isSolo) return [];
  return [charge.partnerName, charge.classCode].filter(
    (value) => value && value !== "-"
  );
}
